<template>
    <el-row class="bottom20">
        <el-row class="column-name" justify="start">
            <span @click="visible = !visible">
                <i class="el-icon-caret-right" v-show="!visible">
                </i>
                <i class="el-icon-caret-bottom" v-show="visible">
                </i>
                部门（{{page.total}}）
            </span>
        </el-row>
        <el-row v-show="visible">
            <department-children-list :search="search" @after-query="handleAfterQuery">

            </department-children-list>
        </el-row>
    </el-row>
</template>

<script>
    import DepartmentChildrenList from "@/views/organization/department/department.children.list";
    export default {
        name: "department.children.list.panel",
        components: { DepartmentChildrenList },
        props: {
            search: {},
        },
        data() {
            return {
                visible: false,
                page: {
                    total: 0,
                    records: [],
                }
            };
        },
        methods: {
            handleAfterQuery(page) {
                this.page = page;
            }
        },
    }
</script>

<style scoped>

</style>